import { cn } from 'src/lib/utils';

function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('animate-pulse rounded-sm-5 bg-[#05050D1A]', className)} {...props} />;
}

export { Skeleton };
